import { Link } from "react-router-dom";
import CustomInput from "./CustomInput";
import PickInput from "./PickInput";
import Button from "./Button";
import NeedHelpLink from "./NeedHelpLink";
import { GooglePersonalizedLoginButton } from "react-google-identity-gsi";

const RegisterForm = () => {
  const CLIENT_ID =
    "226390969933-1fhk9p3l2m33seldtls5f2hgk9bo6btn.apps.googleusercontent.com";
  const buttonCustomization = {
    locale: "en",
    text: "signup_with",
    size: "large",
    width: window.innerWidth > 500 ? "400" : "250",
  };
  const handleCallbackResponse = (response) => {
    console.log(response);
  };
  return (
    <div className="">
      <div className="pb-5">
        <GooglePersonalizedLoginButton
          clientId={CLIENT_ID}
          buttonCustomization={buttonCustomization}
          onUserAuthenticationSucceeded={handleCallbackResponse}
          onUsesrAut
        />
      </div>
      <form action="">
        <div className="flex flex-wrap">
          <div className="pb-5 pr-2 last:pb-0 w-1/2">
            <CustomInput
              label="First Name"
              name={"first-name"}
              type="text"
              placeholder="Enter your First Name"
            />
          </div>
          <div className="pb-5 pl-2 last:pb-0 w-1/2">
            <CustomInput
              label="Last Name"
              name={"last-name"}
              type="text  "
              placeholder="Enter your last name"
            />
          </div>
          <div className="pb-5 last:pb-0 w-full">
            <CustomInput
              label="Email Address"
              name={"register-email"}
              type="email"
              placeholder="Enter your email address"
            />
          </div>
          <div className="pb-5 last:pb-0 w-full">
            <CustomInput
              label="New Password"
              name={"new-password"}
              type="password"
              placeholder="Enter your new password"
            />
          </div>
          <div className="pb-5 last:pb-0 w-full">
            <CustomInput
              label="Re-Type Password"
              name={"re-new-password"}
              type="password"
              placeholder="Re-enter your new password"
            />
          </div>
          <div className="pb-5 last:pb-0 flex text-sm text-[#9e9e9e] w-full">
            <PickInput id={"agree"} name="remember">
              <div>
                <span>I agree to Gepzo </span>
                <span>
                  <Link to="" className="text-[#dc7143]">
                    Consumer Agreement
                  </Link>
                </span>
                <span> and </span>
                <span>
                  <Link to="" className="text-[#dc7143]">
                    Privacy
                  </Link>
                </span>
              </div>
            </PickInput>
          </div>
          <div className="w-full">
            <Link to="/register/step-2">
              <Button width={"w-full"}>Create Account</Button>
            </Link>
          </div>
          <div className="have-no-account pt-5 text-sm text-[#8b8b8b] flex justify-center w-full">
            <NeedHelpLink />
          </div>
        </div>
      </form>
    </div>
  );
};

export default RegisterForm;
